import { EyeOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import { ColumnType } from 'antd/es/table'
import PreviewShipmentBlank from '../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import { getApprovalTaskLabel } from '../../../helpers/entities/shipment/curator-approval'
import Task from '../../../types/api/task'
import CuratorTaskActions from '../components/curator-task-actions'

const formatMeterage = (task: Task): string => {
    const length = task.shipment?.calculated?.materialLength
    if (length == null || Number.isNaN(Number(length))) return '—'
    return `${Number(length).toLocaleString('ru-RU')} м`
}

const formatCopies = (task: Task): string => {
    const positions = task.shipment?.shipment_positions
    if (!positions?.length) return '—'
    const total = positions.reduce((sum, p) => sum + (Number(p.copies) || 0), 0)
    return total.toLocaleString('ru-RU')
}

export const getCuratorTasksColumns = (options?: {
    showActions?: boolean
}): ColumnType<Task>[] => {
    const columns: ColumnType<Task>[] = [
        {
            title: 'Клиент',
            key: 'client',
            render: (_v, record) => record.shipment?.client?.name || '—',
        },
        {
            title: 'Менеджер',
            key: 'manager',
            render: (_v, record) =>
                record.shipment?.user_audit?.created_by_permissions_user?.username || '—',
        },
        {
            title: 'Номер отгрузки',
            key: 'shipmentId',
            width: 110,
            render: (_v, record) => record.shipment?.id ?? '—',
        },
        {
            title: 'Метраж',
            key: 'meterage',
            width: 110,
            render: (_v, record) => formatMeterage(record),
        },
        {
            title: 'Тираж',
            key: 'copies',
            width: 100,
            render: (_v, record) => formatCopies(record),
        },
        {
            title: 'Срок поставки',
            key: 'clientDeliveryDate',
            width: 120,
            render: (_v, record) => record.shipment?.clientDeliveryDate || '—',
        },
        {
            title: 'Согласование',
            key: 'approved',
            width: 220,
            ellipsis: true,
            render: (_v, record) => (
                <Typography.Text ellipsis={{ tooltip: true }}>
                    {getApprovalTaskLabel(record, record.shipment)}
                </Typography.Text>
            ),
        },
        {
            title: 'Производственный бланк',
            key: 'blank',
            width: 160,
            render: (_v, record) => {
                if (!record.shipment) return '—'
                return (
                    <PreviewShipmentBlank
                        blankType='production'
                        shipment={record.shipment}
                        blankPreviewFiles={record.shipment.blankPreviewFiles}
                    >
                        <Button size='small' icon={<EyeOutlined />}>
                            Просмотр
                        </Button>
                    </PreviewShipmentBlank>
                )
            },
        },
    ]

    if (options?.showActions !== false) {
        columns.push({
            title: 'Действия',
            key: 'actions',
            width: 220,
            render: (_v, record) => <CuratorTaskActions task={record} />,
        })
    }

    return columns
}
